export const hospitalPlacementCodesColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'code',
  'fk_hospital__encounter_id',
  'metadata__correlation_derived_date',
  'metadata__correlation_id',
  'metadata__engagement_id',
  'metadata__engagement_name',
  'metadata__modified_by',
  'metadata__modified_date',
  'metadata__pipeline_id',
  'metadata__pipeline_name',
  'name',
  'placement_date',
  'placement_type',
  'return_from_agency_amount',
  'return_from_agency_date',
  'sequence',
  'snapshot_id',
  'transfer_to_agency_amount',
  'user',
];
